// extracted by mini-css-extract-plugin
export var container = "_4z-0";
export var fallback = "_4z-5";
export var fallbackIcon = "_4z-6";
export var hidden = "_4z-2";
export var image = "_4z-3";
export var loaded = "_4z-4";
export var placeholder = "_4z-1";